// extracted by css-extract-rspack-plugin
export default {"Page":"DBYpo","PageHeader":"DGF6J","Decoy":"DeKdJ","PageBody":"VDDdn"};